import { InputSelect } from '../../../../../shared/components/InputSelect';
import { TabPanel } from '@mui/lab';
import { OPTIONS_FINALITY } from '../../../../../shared/utils/const/FinalityOptions';

interface TabFinalidadeProps {
  values: any;
  handleChange: any;
  handleBlur?: any;
  touched?: any;
  errors?: any;
  duploClick?: boolean;
}

/* [30/09] Fora do cadastro de pedido - pedido do Deivid:
 *  - 'Devolução': a devolução nasce de uma venda (botão Devolver), nunca escolhida aqui;
 *  - 'Todos': é opção de FILTRO das telas de pesquisa, não finalidade de venda.
 * A lista OPTIONS_FINALITY continua inteira porque as pesquisas de Pedido e de Contas a
 * Receber usam ela como filtro, e lá as duas opções fazem sentido. */
const FORA_DO_CADASTRO = ['Devolução', 'Todos'];

export const TabFinalidade = ({ values, handleChange, handleBlur, touched, errors, duploClick }: TabFinalidadeProps) => {
  const atual = values?.finalidade?.finalidade;

  /* Pedido que JÁ é devolução continua mostrando 'Devolução' ao ser consultado: a opção
   * atual entra na lista mesmo sendo das escondidas. Sem ela o select ficaria em branco
   * (o valor não bate com nenhuma opção), como se o pedido não tivesse finalidade. */
  const opcoes = OPTIONS_FINALITY.filter(
    (o) => !FORA_DO_CADASTRO.includes(o.value) || o.value === atual
  );

  /* E fica travada: trocar 'Devolução' por 'Normal' transformaria a devolução numa venda,
   * e a opção sumiria da lista - não haveria como desfazer. */
  const travada = FORA_DO_CADASTRO.includes(atual);

  return (
    <TabPanel value={'0'}>
      <div className={'grid grid-cols-8 pt-4'}>
          <InputSelect
            label='Finalidade'
            name='finalidade.finalidade'
            items={opcoes}
            className={'col-span-2'}
            handleBlur={handleBlur}
            handleChange={handleChange}
            value={values?.finalidade?.finalidade ?? null}
            helperText={
              touched?.finalidade?.finalidade &&
                errors?.finalidade?.finalidade
                ? errors?.finalidade?.finalidade
                : ''
            }
            error={
              !!(
                touched?.finalidade?.finalidade &&
                errors?.finalidade?.finalidade
              )
            }
            disabled={duploClick || travada}
          />
      </div>
    </TabPanel>
  );
};
